import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const DeliverySelection = ({
  changeDeliveryOptions,
  deliveryOptions,
  selectedDeliveryOptions,
  product,
}) => {
  return (
    <div
      className={classNames('flex-wrap delivery-selection delivery-more-items')}>
      {deliveryOptions.map((option, i) => {
        let unavailable = false;
        const available =
          product &&
          product.delivery_options.some((option) => option === option.key);
        unavailable = available && !available;
        const isSingleOption = deliveryOptions.length <= 1;
        const deliveryIcon = `icon__${option.type?.toLowerCase()}`;

        return (
          <div
            className={classNames(
              'delivery w-80 ml-2 flex-wrap align-more-items mb-2'
            )}
            key={i}>
            <div
              className={classNames(
                'delivery-option rounded d-flex flex-column',
                {
                  selected: option.key === parseInt(selectedDeliveryOptions),
                  disabled: unavailable,
                  button: !isSingleOption,
                },
              )}
              onClick={() => changeDeliveryOptions(option.key)}>
              <i
                className={`fa ${deliveryIcon} fa-lg ${unavailable && 'disabled'} ${!isSingleOption && 'selectable'}`}
                data-test-id="deliveryIcon"></i>
              <p
                className={classNames('delivery-text', {
                  disabled: unavailable,
                })}>
                {option.mobile_title}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

DeliverySelection.propTypes = {
  changeDeliveryOptions: PropTypes.func.isRequired,
  deliveryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      mobile_title: PropTypes.string,
    }),
  ).isRequired, // Enforce required array of objects with specific shapes
  selectedDeliveryOptions: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  product: PropTypes.arrayOf([PropTypes.object]),
  isMoreOptions: PropTypes.bool,
};

export default DeliverySelection;
